import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { BranchDataTransferInfo } from "projects/sepidz-web-framework/src/lib/models/branch.model";
import { takeUntil } from "rxjs/operators";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";

@Component({
  selector: "ngx-branch-data-transfer-info",
  templateUrl: "./branch-data-transfer-info.component.html",
  styleUrls: ["./branch-data-transfer-info.component.scss"],
})
export class BranchDataTransferInfoComponent extends BaseFormComponent<BranchDataTransferInfo> {
  isOkforLoad: boolean = false;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.apiName = "Branch";
    this.label = this.translate("ClientApp.GNR.Branch.BranchDataTransferInfo");
    super.noLoadData = true;
    super.ngOnInit();
    this.model.OrignalOppositeBranchId = this.model.OppositeBranchId;
  }
  setColumnAttribute() {
    this.orignalColumns = this.getDetailControlModels("BranchDataTransferInfos");
    this.columns = this.orignalColumns.filter(
      (f) => ((!f.areaName || f.areaName === "default") && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
    );
    this.columns = this.columns.sort((a, b) => a.order - b.order);
    super.setColumnAttribute();
  }

  onValueChangeByApiName($event) {
    if ($event && $event.data && $event.data.Title) {
      this.model.OppositeBranchTitle = $event.data.Title;
      this.model.Number = $event.data.Number;
      this.setValue("Number", this.model.Number);
      this.setValue("OppositeBranchTitle", $event.data.Title);
    }
  }
  addControl() {
    this.isOkforLoad = true;
    this.cd.markForCheck();
    if (this.model.OppositeBranchUrl != undefined) this.testConection();
  }
  testConection() {
    if (this.formGroup.controls["OppositeBranchUrl"].value != undefined) {
      var _model = this.getDataFromFormGroup();
      if (!_model.OppositeBranchId) _model.OppositeBranchId = 0;
      this.httpCommonService
        .create("Home/GetOppositeBranchList", _model)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data) => {
            this.selectorService.setDataList("OppositeBranchId", data as []);
          },
          (error) => this.getFailedHelper(error)
        );
    } else
      this.sts.showDialog(this.translate("ClientApp.GNR.Branch.ServerAddressNotComplete"), this.translate("ClientApp.GNR.Branch.ConnectionTest"));
  }
  async save() {
    this.selectorService.submitted$.next(this.submitted);
    if (this.model.State === RowState.NoChange) this.model.State = RowState.Modify;
    this.result = this.getDataFromFormGroup();
    this.closeModal();
  }
}
